enum routes {
    auth = "",
    login = "login",
    signup = "signup",
    splash = "splash",
    recoverPassword = "recover-password",
    panel = "panel",
    profile = "profile",
    token = "token",
    home = "report",
    dashboard = "dashboard",
    notifications = "notifications",
    report = "report",
    applicationReport = "application-report",
    changePassword = "change-password",
    document = "document",
    bankAccount = "bank-account",
    poDashboard = "po-dashboard",
    poReport = "po-report",
    paymetsReport = "payments-report",
    poPaymetsReport = "po-payments-report",
    transactionsReport = "transactions-report",
    poTransactionsReport = "po-transactions-report",
    poApplicationReport = "po-application-report",
    settlementReport = "settlement-report",
    tracker = "tracker",
    paymentLink = "payment-link",
    //=== admin
    adminUser = "admin-user",
    adminTerminal = "admin-terminal",
    adminBehpardakhtExeption = "admin-behpardakht-exception"
}
export const navigateTo = {
    ...Object.keys(routes).reduce((acc, k) => ({
        ...acc,
        [k]: `/panel/${routes[k as keyof typeof routes]}`
    }), {}) as { [k in keyof typeof routes]: string },
    auth: "/",
    login: "/login",
    signup: "/signup",
    splash: "/splash",
    recoverPassword: "/recover-password",
    panel: "/panel"
};
export default routes;